/**
 * Plugins Index
 * 
 * Export plugin registry and initialize built-in plugins.
 */

export { pluginRegistry, PluginRegistry } from './PluginRegistry.js';
export { registerBuiltInTransforms } from './builtInTransforms.js';
export { registerBuiltInValidators } from './builtInValidators.js';

import { registerBuiltInTransforms } from './builtInTransforms.js';
import { registerBuiltInValidators } from './builtInValidators.js';

/**
 * Initialize all built-in plugins
 * Call this once at application startup
 */
export function initializePlugins() {
  registerBuiltInTransforms();
  registerBuiltInValidators();
}
